import { render } from "./storeBanner.vue?vue&type=template&id=bd533a4e&scoped=true"
import script from "./storeBanner.vue?vue&type=script&lang=js"
export * from "./storeBanner.vue?vue&type=script&lang=js"

import "./storeBanner.vue?vue&type=style&index=0&id=bd533a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd533a4e"]])

export default __exports__